<template>
  <div id="section-tips" class="col-12 p-0">
    <div class="container">
      <router-link v-if="!screen" to="/" class="fa fa-2x fa-times d-lg-flex"></router-link>
      <div class="row m-0">
        <div class="col-10 col-lg-8 px-0 text-center mx-auto my-3">
          <h4>Termos e Dicas de Uso</h4>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row mx-0">
        <div class="col-12 col-md-7 col-lg-5 mx-auto px-0 py-3 callout-x alert-dark ">
          <p class="text-lg text-center my-0">Valide sua assinatura </p>
          <p class="text-lg text-center my-0"> Validador Público -
            <router-link to="/consulta-publica" target="_blank">clique aqui</router-link>
          </p>
        </div>
      </div>
      <div class="row my-2 mx-0 justify-content-center">
        <template v-for="(termo,id) in termos">
          <div :key="termo.id" :class="(termoshow==id) ? 'col-lg-10' : 'col-lg-5'" class="accordion col-md-10 m-3 px-0"
            id="accordionTermos">
            <div class="card px-0">
              <div @click="showTermo(id)" class="col-md-12 card-header bg-white px-0 text-center" :id="`heading${id}`"
                data-toggle="collapse" :data-target="`#collapse${id}`" aria-expanded="false" :href="`#heading${id}`"
                :aria-controls="`collapse${id}`">
                <img class="w-auto" :src="require(`@/assets/login/dicas/Imagemtermo.jpg`)" alt="" />
                <h2 class="mb-0 text-center"> {{termo.termo_descricao}} </h2>
              </div>
            </div>
            <div :id="`collapse${id}`" class="collapse col-md-12 card" :aria-labelledby="`heading${id}`"
              data-parent="#accordionTermos" v-html="termo.termo_conteudo" style="cursor: default"></div>
          </div>
        </template>
        <template v-for="(item,i) in tips">
          <div v-show="(!visible || visible==(i+1))" :key="`tips-${i}`" @click="show(item,i)"
            :class="(!visible)? 'col-lg-5 ': 'col-lg-8'" class="col-md-10 card m-3 py-3">
            <img class="w-100" :src="require(`@/assets/login/dicas/${item.image}.jpg`)" alt="" />
            <h2 :class="{'pb-3': item.visible}">{{item.title}}</h2>
            <template v-if="item.visible">
              <p v-for="(x, xi) in item.p" :key="`p-${xi}`" :class="{'title': (item.weight).includes(xi)}">
                {{x}}
              </p>
              <p>Fonte: {{item.font}}</p>
            </template>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['screen'],
    data() {
      return {
        visible: false,
        termos: [],
        termoshow: null,
        tips: [{
            title: 'Saiba como será a emissão primária de certificado digital remotamente',
            image: 'resultado',
            visible: false,
            p: ['A pandemia fez com que muitos serviços que antes eram feitos obrigatoriamente de forma presencial precisassem se adaptar a uma nova realidade.',
              'O distanciamento social reduziu o número de pessoas trabalhando em postos físicos, o que poderia aumentar aglomerações nestes locais – algo bastante contraindicado para o enfrentamento do novo coronavírus. A emissão de certificado digital foi um dos serviços que teve de se adaptar às novas condições, adotando um sistema de trabalho virtual.',
              'Para isso, o CG da ICP-Brasil (Comitê Gestor da Infraestrutura de Chaves Públicas Brasileiras) aprovou a emissão primária dos certificados digitais de maneira remota, por meio de videoconferência. Essa medida poderá modernizar e deixar mais rápida a emissão e poderá voltar a ser feita assim que a Instrução Normativa sobre os procedimentos for publicada.',
              'A aprovação do Comitê Gestor da ICP-Brasil veio após a combinação técnica do uso da biometria e da videoconferência na validação do requerimento para o certificado digital, de modo a garantir a credibilidade do serviço sem a presença do titular nos pontos autorizados.',
              'Método já havia sido testado em 2020',
              'O uso da videoconferência, no início da pandemia, para a emissão de certificados digitais foi essencial para a aprovação da tecnologia pelo ICP-Brasil, comprovando-se um método eficiente e seguro. As conferências on-line foram usadas de maneira emergencial, a partir de abril de 2020, e monitoradas pelo ITI (Instituto Nacional de Tecnologia da Informação).',
              'Os resultados das análises foram discutidos para que a CG ICP-Brasil pudesse aprovar o método como uma maneira alternativa definitiva para a emissão primária dos certificados. Uma das principais preocupações era a respeito da segurança dos procedimentos, a fim de evitar fraudes e manter a credibilidade do serviço.',
              'A expectativa é que o serviço possa ser prestado de maneira remota já no início de maio.',
              'Como funciona atualmente',
              'Enquanto a emissão primária dos certificados digitais não pode ser feito de maneira remota, continua valendo a exigência de estar presencialmente em algum dos pontos autorizados para o serviço. Apenas as renovações dos certificados podem ser feitas de maneira remota, por videoconferência.',
              'Quando as novidades estiverem totalmente implementadas, a primeira solicitação de certificado poderá ser feita totalmente on-line, sem a necessidade de sair de casa para nenhuma das etapas do processo. Isso tornará todo o procedimento mais simples, rápido e seguro para quem busca a certificação digital.',
            ],
            weight: [4, 8],
            font: 'Redação Bonde com Assessoria de Imprensa',
          },
          {
            title: 'Simplificação da Assinatura Eletrônica permite ampliar serviços digitais',
            image: 'estoque',
            visible: false,
            p: ['Desde 2001, com a criação da Infraestrutura de Chaves Públicas Brasileira (ICP Brasil), os documentos digitais passaram a ter validade jurídica em todo o Brasil e podem ainda substituir totalmente o papel, desde que assinados digitalmente.',
              'No entanto, ainda hoje, muitas são as dúvidas e poucos os casos de uso efetivo dessa modalidade entre contratos comerciais. Um dos grandes entraves para ampliação do uso é a obrigatoriedade do Certificado Digital, que nada mais é do que uma identidade eletrônica concedida tanto para empresas como pessoa física para atestar a identificação do usuário.',
              'É a partir desse documento que se pode obter uma assinatura digital e então imprimir sua autenticação em documentos e formulários online, dispensando os tradicionais reconhecimentos de firma em cartório. O certificado digital no padrão ICP é fornecido por uma das mais de 1,4 mil Autoridades de Registro credenciadas em todo o país de forma presencial.',
              'Nem todas as assinaturas necessitam desse certificado, mas, sem dúvida, tais procedimentos tornam os procedimentos mais morosos e burocráticos. No caso das empresas, todas aquelas obrigadas à emissão de NF-e precisam da validação. Já os MEIs podem variar de estado para estado. Com o auxílio dessa solução, as pessoas jurídicas podem enviar ao governo informações trabalhistas, previdenciárias e fiscais.',
              'Para profissionais liberais e pessoas físicas em geral, o recurso é obrigatório para alguns tipos de transações, tais como assinatura de contratos, procurações online, acesso ao site da Receita Federal, escriturações contábeis e fiscais, entre outras. A exigência do dispositivo para declaração de imposto de renda continua restrita para valores acima de R$ 10 milhões.',
              'Desde 2020, a utilização do software para contribuintes abaixo dessa faixa de renda, embora não obrigatória, trouxe vantagens, tais como a possibilidade de visualizar a declaração semipronta com o pré-preenchimento das informações que já estão na base de dados da Receita, tais como bens, doações, rendimentos recebidos, tributáveis ou não, evitando, assim, erros com preenchimentos manuais.',
              'Simplificação da assinatura eletrônica',
              'Mais tarde, o governo criou novos meios de assinatura para tentar simplificar o registro eletrônico de alguns tipos de documentos. Com a criação das assinaturas simples e avançadas, algumas transações de baixo risco e relevância puderam ser realizadas sem a exigência do certificado ICP-Brasil, enquanto apenas a assinatura qualificada manteve a obrigatoriedade.',
              'A simplificação dessa funcionalidade se mostrou especialmente relevante durante a pandemia, quando diversos serviços precisaram migrar para o atendimento à distância. O setor financeiro, que até então, mantinha grande parte de suas operações em agências físicas, rapidamente abriu canais digitais para continuar com o atendimento, mesmo com as medidas de distanciamento social.',
              'Com isso, formalizações de contratos de crédito, consórcio e financiamento puderam ser concluídas de maneira remota, com o uso de plataformas especializadas que obedecem às exigências legais que cada transação requer. Graças ainda ao recurso de assinatura eletrônica, o procedimento pode ser finalizado integralmente em a necessidade da presença do usuário.',
              'Serviços de digitalização e processamento de documentos terceirizados permitiram ampliar significativamente o leque de opções, ao conseguir capturar e transformar qualquer documento físico em formato digital, de maneira autenticada e verificada, com reconhecimento de caracteres, marcas e até conversão de código de barras, com armazenamento criptografado e uso de assinatura digital padrão ICP-Brasil.',
              'Via de regra, a assinatura eletrônica já se provou segura, além de possuir os mesmos valores jurídicos que uma assinatura manuscrita com reconhecimento de firma. Essa funcionalidade, aliada à Lei de Digitalização de documentos e serviços especializados de Gestão e Guarda Segura de arquivos, promete, aos poucos, abolir a necessidade de se imprimir grandes volumes de papeis, que circulam de um lado para o outro recolhendo assinaturas, colocando, assim, em risco a privacidade e proteção dos dados pessoais, além de informações críticas das empresas.',
            ],
            weight: [6],
            font: 'Por Marcelo Carreira, Diretor de Marketing da Access',
          },
          {
            title: 'Certificado digital: por que as empresas precisam ter o documento eletrônico?',
            image: 'financeiro',
            visible: false,
            p: ['Entenda quais empresas precisam ter o certificado digital e em quais processos ele é necessário.',
              'Muitos empresários ainda se perguntam quais os prejuízos de não ter um certificado digital, se ele realmente é necessário. É importante lembrar que sem o certificado, as empresas ficam impedidas de enviar ao governo as informações trabalhistas, previdenciárias e fiscais.',
              'Todas as empresas que seguem os regimes tributários de Lucro Real ou Lucro Presumido, devem possuir um certificado digital. Isso porque, elas são obrigadas a emitir Nota Fiscal eletrônica, ou seja, todo mundo que expede nota, nas operações de venda de mercadorias que têm a incidência do Imposto sobre Circulação de Mercadorias e Serviços – ICMS, está obrigado a se certificar.',
              'Também vale lembrar que a maioria das declarações pleiteadas pela Receita Federal do Brasil (RFB) para as empresas tanto do Lucro Real, quanto do Presumido exigem a certificação.',
              'As empresas optantes pelo Simples Nacional que possuem mais de três empregados também têm que ter a ferramenta.',
              'Restrições sem Certificado Digital',
              'As empresas que não possuem o certificado digital ficam impedidas de enviar ao governo as informações trabalhistas, previdenciárias e fiscais. Uma empresa do Super Simples, por exemplo, não terá condições de remeter a Guia de Recolhimento do FGTS e de Informações à Previdência Social – Gfip e o eSocial, ficando sujeita a multas e sanções administrativas.',
              'Até os microempreendedores individuais que emitem NF-e de alguns Estados se não estiverem devidamente certificados, terão problemas na hora de despachar as suas mercadorias, principalmente se as vendas forem feitas pela Internet.',
              'Outra desvantagem para a empresa que não utilizar o certificado digital é a impossibilidade de transmitir as declarações das obrigações acessórias, não conseguindo pagar os tributos exigidos por lei.',
              'Se não cumprir com o pagamento de tributos, terá que pagar multas. Neste caso, a multa é de 20% do imposto que não for declarado, sendo o valor de, no mínimo, R$ 500.',
              'No caso do lançamento de NF-e, a multa é sobreposta sobre o comprador — isso torna a finalização de negociações mercatórias mais dificultosa para o estabelecimento.'
            ],
            weight: [0, 5],
            font: 'Portal Contábeis',
          },
          // {
          //   title: '',
          //   image: '',
          //   visible: false,
          //   p: [],
          //   weight: [],
          //   font: '',
          // },
        ]
      }
    },
    beforeMount() {
      this.$store.dispatch('getEula').then(response => {
        this.termos = response;
      });
    },
    methods: {
      showTermo(payload) {
        let alltermos = document.querySelectorAll('#accordionTermos .collapse');
        Array([...alltermos]).map(termo => termo.map((t, i) =>
          (i != payload) ? $(`#${t.id}`).removeClass("show") : false));
        this.termoshow = (this.termoshow != payload) ? payload : null;
      },
      show(payload, pos) {
        this.visible = (!this.visible) ? (pos + 1) : false;
        payload.visible = !payload.visible;
      }
    }
  }
</script>


<style scoped src="@/assets/sass/bootstrap.min.css"></style>
<style scoped>
  a.fa-times {
    color: #ff4d4d;
    text-decoration: none;
    cursor: pointer;
    position: fixed;
    top: 3vw;
    left: 1.5vw;
    z-index: 20;
  }

  [id*='section-'] {
    background-color: #f8f9fa !important;
    font-family: 'Montserrat';
    min-height: 100vh;
    /* z-index: 10; */
  }

  h4 {
    font-size: 32px;
    line-height: 1.1875;
    font-family: "Montserrat";
  }

  .card {
    border: 0;
    background-color: #fff;
    border-radius: 5px;
    text-align: justify;
    transition: transform 0.3s, height 2s;
  }

  .card:hover {
    border: 0;
    box-shadow: 0px 0px 10px 3px #888888;
    cursor: pointer;
  }

  .card:hover.col-lg-5 {
    transform: scale(1.05);
  }

  .card img {
    max-width: 500px;
    align-self: center;
  }

  .title {
    font-weight: 600;
  }

  p,
  h2 {
    color: #333;
  }

  @media screen and (max-width: 992px) {
    h4 {
      font-size: 22px;
    }
  }
</style>